/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

function ReplenishModelDenominations({ denominations, type }: any) {
  return (
    <Grid data={denominations}>
      {type === "single" && (
        <GridColumn field="description" title="Description" />
      )}
      <GridColumn field="denomination" title="Denomination" />
      {type === "single" && (
        <>
          <GridColumn field="type" title="Type" />
          <GridColumn field="maker" title="Maker" />
        </>
      )}
      <GridColumn
        width="100"
        field="noOfCassettes"
        title="Cassettes"
        className="text-center"
      />
      <GridColumn width="100" field="noOfNotes" title="Notes" />
      {type === "single" && (
        <GridColumn width="100" field="limit" title="Limit" />
      )}
    </Grid>
  );
}

export default React.memo(ReplenishModelDenominations);
